import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-4">
              <div className="info-side">
                <div className="text fsz-24 color-333 lh-3 fw-600">
                  Metalwork is a lasting expression of creativity, inspiring communities and leaving an imprint on the future.
                </div>
                <div className="foot-social mt-50">

                  <a href="https://www.facebook.com/profile.php?id=61576007352107">
                    <i className="fab fa-facebook-f"></i>
                  </a>

                </div>
              </div>
            </div>
            <div className="col-lg-3 offset-lg-2">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Tempe, AZ </h5>
                <ul className="footer-links">
                  <li>
                    <a href="mailto:info@tempefab.com"> info@tempefab.com </a>
                  </li>
                  <li>
                    AZROC #359773
                    <a href="">  </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-6">
              <p className="fsz-13">© 2025 Tempe Fabrication LLC. All Right Reserved</p>
            </div>
            <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="/"> Home </a>
                <a href="/portfolio"> Portfolio </a>
                <a href="/contact"> Contact </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
